import { api } from "@/api/client";
import { unwrap } from "@/api/errors";

/**
 * DELETE /v1/me — permanently delete the current account. The backend attempts
 * to cancel every active Polar subscription first, removes the Clerk identity, deletes database data,
 * and queues stored objects for deletion. Store subscriptions remain managed
 * by Apple or Google. Irreversible; the caller signs out afterwards.
 */
export async function deleteAccount(): Promise<void> {
  unwrap(await api.DELETE("/v1/me"));
}
